import RestauranteCardapioItem from "./RestauranteCardapioItem";
import GrupoComida from "./GrupoComida";

export default class RestauranteCardapioComidaItem extends RestauranteCardapioItem {

    grupo?: GrupoComida;
    quantidadePessoas?: number;
    destaque?: boolean;

}